module.exports = __webpack_public_path__ + "static/img/8.2cb4d3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/eng/8.png
// module id = 3Yd8
// module chunks = 0